import { render, staticRenderFns } from "./productosSolicitadosPorCedis.vue?vue&type=template&id=f5979284&"
import script from "./productosSolicitadosPorCedis.vue?vue&type=script&lang=js&"
export * from "./productosSolicitadosPorCedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports